import React from "react";

export default function Footer() {
    return (
        <footer id="pg-ftr">
            <div className="pg-ftr-wrapper">
                <section className="slice bottom">
                    <div className="wrapper">
                        <div className="slice-content">
                            <p className="copyright">
                                &copy; Inter IKEA Systems B.V 1999-{(new Date().getFullYear())}
                            </p>
                        </div>
                    </div>
                </section>
            </div>
        </footer>
    );
}